var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import styled from "styled-components";
import { Button, Grid, Typography, FormControlLabel, Checkbox } from "@material-ui/core";
import TestProgressBar from "./TestProgressBar";
import { useTranslation } from "react-i18next";
var OutputColor;
(function (OutputColor) {
  OutputColor["Orange"] = "rgb(255, 128, 0)";
  OutputColor["Gray"] = "#E8E8E8";
})(OutputColor || (OutputColor = {}));
var StyledOutputTitle = styled(function (_a) {
  var backgroundColor = _a.backgroundColor,
    props = __rest(_a, ["backgroundColor"]);
  return React.createElement(Grid, __assign({
    container: true,
    item: true,
    direction: "row",
    alignItems: "center",
    justify: "space-between"
  }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: black;\n  border-radius: 3px 3px 0 0;\n  padding: 5px;\n"], ["\n  background-color: ", ";\n  color: black;\n  border-radius: 3px 3px 0 0;\n  padding: 5px;\n"])), function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
});
var OutputTitleText = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 5px;\n  margin-left: 10px !important;\n  color: #252525;\n"], ["\n  display: inline-block;\n  padding: 5px;\n  margin-left: 10px !important;\n  color: #252525;\n"])));
var StyledOutputContent = styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px;\n  display: table-cell;\n"], ["\n  padding: 10px;\n  display: table-cell;\n"])));
var StyledButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 5px !important;\n"], ["\n  margin: 5px !important;\n"])));
var OutputBox = function (props) {
  return React.createElement(Grid, {
    container: true,
    direction: "column"
  }, props.children);
};
var OutputButton = function (props) {
  return React.createElement(StyledButton, {
    disabled: props.disabled,
    onClick: props.onClick,
    variant: "contained",
    "data-cy": props.dataCy,
    className: props.className
  }, props.label);
};
var OutputHeaderText = styled(Typography)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0 10px !important;\n  color: black;\n"], ["\n  margin: 0 10px !important;\n  color: black;\n"])));
var OutputBody = function (props) {
  return React.createElement(StyledOutputContent, null, props.children);
};
var OutputHeader = function (props) {
  var children = props.children,
    color = props.color,
    title = props.title;
  return React.createElement(StyledOutputTitle, {
    backgroundColor: color
  }, React.createElement(Grid, {
    item: true,
    xs: 4
  }, React.createElement(OutputTitleText, {
    variant: "h6"
  }, title)), React.createElement(Grid, {
    container: true,
    item: true,
    xs: 8,
    alignItems: "center",
    justify: "flex-end"
  }, children));
};
var OutputFooterWithPercentage = function (props) {
  var children = props.children,
    color = props.color,
    percentage = props.percentage,
    showAll = props.showAll,
    setShowAll = props.setShowAll,
    showAllDisabled = props.showAllDisabled;
  var t = useTranslation()[0];
  return React.createElement(StyledOutputTitle, {
    backgroundColor: color
  }, React.createElement(Grid, {
    style: {
      borderRight: "solid 1px lightgray"
    },
    item: true,
    xs: 3
  }, React.createElement(FormControlLabel, {
    label: t("showAll"),
    style: {
      paddingLeft: "5px"
    },
    control: React.createElement(Checkbox, {
      checked: showAll,
      disabled: showAllDisabled,
      onChange: function () {
        return setShowAll === null || setShowAll === void 0 ? void 0 : setShowAll(!showAll);
      },
      color: "primary",
      "data-cy": "show-all-results-checkbox"
    })
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(TestProgressBar, {
    percentage: percentage
  })), React.createElement(Grid, {
    container: true,
    item: true,
    xs: 3,
    alignItems: "center",
    justify: "flex-end"
  }, children));
};
var OutputFooter = function (props) {
  var children = props.children,
    color = props.color;
  var t = useTranslation()[0];
  return React.createElement(StyledOutputTitle, {
    backgroundColor: color
  }, React.createElement(Grid, {
    style: {
      borderRight: "solid 1px lightgray"
    },
    item: true,
    xs: 3
  }, React.createElement(FormControlLabel, {
    label: t("showAll"),
    style: {
      paddingLeft: "5px"
    },
    control: React.createElement(Checkbox, {
      checked: false,
      disabled: true,
      color: "primary",
      "data-cy": "show-all-results-checkbox"
    })
  })), React.createElement(Grid, {
    item: true,
    xs: 5
  }), React.createElement(Grid, {
    container: true,
    item: true,
    xs: 4,
    alignItems: "center",
    justify: "flex-end"
  }, children));
};
export { OutputBox, OutputBody, OutputHeader, OutputButton, OutputColor, OutputHeaderText, OutputFooter, OutputFooterWithPercentage };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;